import type { PayzheBtpJobStatus } from './types';

export const PAYZHE_BTP_TERMINAL_JOB_STATUSES = [
  'completed',
  'failed',
  'cancelled',
  'expired',
] as const;

export type PayzheBtpTerminalJobStatus = (typeof PAYZHE_BTP_TERMINAL_JOB_STATUSES)[number];

export function isTerminalPayzheBtpJobStatus(status: string): status is PayzheBtpTerminalJobStatus {
  return (PAYZHE_BTP_TERMINAL_JOB_STATUSES as readonly string[]).includes(status);
}

type JobWaitListener = (status: PayzheBtpJobStatus, lastError?: string) => void;

const waiters = new Map<string, Set<JobWaitListener>>();

export function registerPayzheBtpJobWait(jobId: string, listener: JobWaitListener): () => void {
  let set = waiters.get(jobId);
  if (!set) {
    set = new Set();
    waiters.set(jobId, set);
  }
  set.add(listener);
  return () => {
    set?.delete(listener);
    if (set && set.size === 0) {
      waiters.delete(jobId);
    }
  };
}

export function notifyPayzheBtpJobTerminal(
  jobId: string,
  status: PayzheBtpJobStatus,
  lastError?: string,
): void {
  const set = waiters.get(jobId);
  if (!set) return;
  for (const listener of set) {
    try {
      listener(status, lastError);
    } catch {
      /* ignore */
    }
  }
  if (isTerminalPayzheBtpJobStatus(status)) {
    waiters.delete(jobId);
  }
}
